import React from 'react'
import { withFirebase } from '../Fb'

// reactstrap components
import {
  Row,
  Col
} from 'reactstrap'

import MaintenancePlan from './MaintenancePlan.jsx'
import MaintenancePlanInfo from './MaintenancePlanInfo.jsx'

const service = 'maintenancetickets'
// core components

class BuildingMaintenancePlanContainer extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      saving: false,
      enabled: false,
    }
  }


  componentDidMount() {
    if (this.props.modules && this.props.modules[service] && this.props.modules[service].enabled) {
      this.setState({ enabled: true })
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.modules && this.props.modules[service]) {
      if (this.props.modules[service].enabled && !prevProps.modules[service]?.enabled) {
        this.setState({ enabled: true })
      } 
      if (!this.props.modules[service].enabled && prevProps.modules[service]?.enabled) {
        this.setState({ enabled: false })
      }
    } else {
      if(this.state.enabled) {
        this.setState({ enabled: false })
      }
    }
  }

  enableModule = async (price) => {
    this.setState({ saving: true })
    await this.props.firebase.enableModule(service, price)
  }

  render() {
    if (!this.state.enabled) {
      return (
        <>
          <div className='content'>
            <Row>
              <Col md='12'>
                <MaintenancePlanInfo onSubmit={this.enableModule} saving={this.state.saving} />
              </Col>
            </Row>
          </div>
        </>
      )
    } else {
      return (
        <>
          <div className='content'>
            <Row>
              <Col md='12'>
                <MaintenancePlan />
              </Col>
            </Row>
          </div>
        </>
      )
    }
  }
    
}

export default withFirebase(BuildingMaintenancePlanContainer)
